import { render, staticRenderFns } from "./AnalyticsPage.vue?vue&type=template&id=52e2f961&scoped=true&lang=pug&"
import script from "./AnalyticsPage.vue?vue&type=script&lang=js&"
export * from "./AnalyticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2f961",
  null
  
)

export default component.exports